import { useEffect, Children } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import * as amplitude from '@amplitude/analytics-browser';
import { plugin as engagementPlugin } from '@amplitude/engagement-browser';

import useEnvironment from 'hooks/useEnvironment';

export function AmplitudeProvider({ children }) {
  const { amplitudeKey } = useEnvironment();
  const history = useHistory();

  useEffect(() => {
    if (!amplitudeKey) return;

    amplitude.init(amplitudeKey, { defaultTracking: false });
    amplitude.add(engagementPlugin());

    // SPA router for multi-step Guides: lets Amplitude navigate between steps
    // without a full page reload. Equivalent to the legacy CommandBar.addRouter.
    window.engagement?.setRouter?.((url) => history.push(url));
  }, [amplitudeKey, history]);

  return Children.only(children);
}

AmplitudeProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

export default AmplitudeProvider;
